/**
 * Dropdown navigation
 *
 * @param {string} el - selector for nav that should become a dropdown
 */

// Note: DOM operations are quite performance intensive in JS, but setting up
//       ARIA-related attributes this way also kind of ensures that the nav is
//       still usable w/out JS; if we ever encounter performance issue with the
//       JS, it would be an option to not set these in JS, but in the markup

import $ from 'jquery';

import { keyCodes } from './utils/keyCodes';

export const navDropdown = (el = '#ghwp-main-nav') => {
    // Add ARIA role to menubar and menu items
    $(el).attr('role', 'menubar').find('li').attr('role', 'menuitem');

    var top_level_links = $(el).find('> li > a');

    if (window.matchMedia('(min-width: 1200px)').matches) {
        // Get width of widest top level link
        var top_level_maxWidth = Math.max.apply(
            null,
            $(top_level_links)
                .map(function () {
                    return $(this).outerWidth(false);
                })
                .get()
        );

        if (top_level_maxWidth < 310) top_level_maxWidth = 310;

        // Set width of all dropdown menus
        $(el)
            .find('[data-sub=true]')
            .each(function () {
                $(this).css('width', Math.ceil(top_level_maxWidth));
            });
    }

    // Set tabIndex to -1 so that top_level_links can't receive focus until menu is open
    $(top_level_links)
        .next('ul')
        .attr('data-sub', 'true')
        .attr({ 'aria-hidden': 'true', role: 'menu' })
        .find('a')
        .attr('tabIndex', -1);

    // Adding aria-haspopup for appropriate items
    $(top_level_links).each(function () {
        if ($(this).next('ul').length > 0)
            $(this).parent('li').attr('aria-haspopup', 'true');
    });

    $(top_level_links).click(function (e) {
        if ($(this).parent().attr('aria-haspopup') === 'true') {
            e.preventDefault();
        }

        if (window.matchMedia('(max-width: 1199px)').matches) {
            $(top_level_links).each(function () {
                var $item = $(this);
                if ($item.parent().attr('aria-haspopup') === 'true') {
                    $item.removeClass('expanded');
                }
            });
            if ($(this).parent().attr('aria-haspopup') === 'true') {
                $(this).addClass('expanded');
            }

            $(this)
                .closest('ul')
                .attr('aria-hidden', 'false')
                .find('.' + 'show-menu')
                .attr('aria-hidden', 'true')
                .removeClass('show-menu')
                .find('a')
                .attr('tabIndex', -1);
            $(this)
                .next('ul')
                .attr('aria-hidden', 'false')
                .addClass('show-menu')
                .find('a')
                .attr('tabIndex', 0);
        }
    });

    if (window.matchMedia('(min-width: 1200px)').matches) {
        $(top_level_links).hover(function () {
            $(this)
                .closest('ul')
                .attr('aria-hidden', 'false')
                .find('.' + 'show-menu')
                .attr('aria-hidden', 'true')
                .removeClass('show-menu')
                .find('a')
                .attr('tabIndex', -1);
            $(this)
                .next('ul')
                .attr('aria-hidden', 'false')
                .addClass('show-menu')
                .find('a')
                .attr('tabIndex', 0);
        });

        $(top_level_links).focus(function () {
            $(this)
                .closest('ul')
                .find('.' + 'show-menu')
                .attr('aria-hidden', 'true')
                .removeClass('show-menu')
                .find('a')
                .attr('tabIndex', -1);

            $(this)
                .next('ul')
                .attr('aria-hidden', 'false')
                .addClass('show-menu')
                .find('a')
                .attr('tabIndex', 0);
        });

        $(top_level_links).mouseleave(function () {
            var $el = $(this);

            $el.closest('ul')
                .attr('aria-hidden', 'false')
                .find('.' + 'show-menu')
                .attr('aria-hidden', 'true')
                .removeClass('show-menu')
                .find('a')
                .attr('tabIndex', -1);
        });

        // Bind arrow keys for navigation
        $(top_level_links).keydown(function (e) {
            if (e.keyCode == 37) {
                e.preventDefault();
                // This is the first item
                if ($(this).parent('li').prev('li').length == 0) {
                    $(this)
                        .parents('ul')
                        .find('> li')
                        .last()
                        .find('a')
                        .first()
                        .focus();
                } else {
                    $(this).parent('li').prev('li').find('a').first().focus();
                }
            } else if (e.keyCode == 38) {
                e.preventDefault();
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this)
                        .parent('li')
                        .find('ul')
                        .attr('aria-hidden', 'false')
                        .addClass('show-menu')
                        .find('a')
                        .attr('tabIndex', 0)
                        .last()
                        .focus();
                }
            } else if (e.keyCode == 39) {
                e.preventDefault();
                // This is the last item
                if ($(this).parent('li').next('li').length == 0) {
                    $(this)
                        .parents('ul')
                        .find('> li')
                        .first()
                        .find('a')
                        .first()
                        .focus();
                } else {
                    $(this).parent('li').next('li').find('a').first().focus();
                }
            } else if (e.keyCode == 40) {
                e.preventDefault();
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this)
                        .parent('li')
                        .find('ul')
                        .attr('aria-hidden', 'false')
                        .addClass('show-menu')
                        .find('a')
                        .attr('tabIndex', 0)
                        .first()
                        .focus();
                }
            } else if (e.keyCode == 13 || e.keyCode == 32) {
                // If submenu is hidden, open it
                e.preventDefault();
                $(this)
                    .parent('li')
                    .find('ul[aria-hidden=true]')
                    .attr('aria-hidden', 'false')
                    .addClass('show-menu')
                    .find('a')
                    .attr('tabIndex', 0)
                    .first()
                    .focus();
            } else if (e.keyCode == 27) {
                e.preventDefault();
                $('.' + 'show-menu')
                    .attr('aria-hidden', 'true')
                    .removeClass('show-menu')
                    .find('a')
                    .attr('tabIndex', -1);
            } else {
                $(this)
                    .parent('li')
                    .find('ul[aria-hidden=false] a')
                    .each(function () {
                        if (
                            $(this).text().substring(0, 1).toLowerCase() ==
                            keyCodes[e.keyCode]
                        ) {
                            $(this).focus();
                            return false;
                        }
                    });
            }
        });

        var links = $(top_level_links).parent('li').find('ul').find('a');

        $(links).keydown(function (e) {
            if (e.keyCode == 38) {
                e.preventDefault();
                // This is the first item
                if ($(this).parent('li').prev('li').length == 0) {
                    $(this)
                        .parents('ul')
                        .parents('li')
                        .find('a')
                        .first()
                        .focus();
                } else {
                    $(this).parent('li').prev('li').find('a').first().focus();
                }
            } else if (e.keyCode == 40) {
                e.preventDefault();
                if ($(this).parent('li').next('li').length == 0) {
                    $(this)
                        .parents('ul')
                        .parents('li')
                        .find('a')
                        .first()
                        .focus();
                } else {
                    $(this).parent('li').next('li').find('a').first().focus();
                }
            } else if (e.keyCode == 27 || e.keyCode == 37) {
                e.preventDefault();
                $(this)
                    .parents('ul')
                    .first()
                    .prev('a')
                    .focus()
                    .parents('ul')
                    .first()
                    .find('.' + 'show-menu')
                    .attr('aria-hidden', 'true')
                    .removeClass('show-menu')
                    .find('a')
                    .attr('tabIndex', -1);
            } else if (e.keyCode == 32) {
                e.preventDefault();
                window.location = $(this).attr('href');
            } else {
                var found = false;
                $(this)
                    .parent('li')
                    .nextAll('li')
                    .find('a')
                    .each(function () {
                        if (
                            $(this).text().substring(0, 1).toLowerCase() ==
                            keyCodes[e.keyCode]
                        ) {
                            $(this).focus();
                            found = true;
                            return false;
                        }
                    });

                if (!found) {
                    $(this)
                        .parent('li')
                        .prevAll('li')
                        .find('a')
                        .each(function () {
                            if (
                                $(this).text().substring(0, 1).toLowerCase() ==
                                keyCodes[e.keyCode]
                            ) {
                                $(this).focus();
                                return false;
                            }
                        });
                }
            }
        });

        // Hide menu if click or focus occurs outside of navigation
        $(el)
            .find('a')
            .last()
            .keydown(function (e) {
                if (e.keyCode == 9) {
                    // If the user tabs out of the navigation hide all menus
                    $('.' + 'show-menu')
                        .attr('aria-hidden', 'true')
                        .removeClass('show-menu')
                        .find('a')
                        .attr('tabIndex', -1);
                }
            });
    }

    $(document).click(function () {
        $(top_level_links).each(function () {
            var $item = $(this);
            if ($item.parent().attr('aria-haspopup') === 'true') {
                $item.removeClass('expanded');
            }
        });

        $('.' + 'show-menu')
            .attr('aria-hidden', 'true')
            .removeClass('show-menu')
            .find('a')
            .attr('tabIndex', -1);
    });

    $(el).click(function (e) {
        e.stopPropagation();
    });
};
